module.exports = __webpack_public_path__ + "c4a5d48d0d9c55578ba37f0aaca96b90.MP3";